import { API_URL } from '../../../app-config/constants';
import { post } from '../request';

export function createExportReviewCycleJob(args) {
    return post(`${API_URL}/review-cycles/` + args.id + '/export_pdf', { postData: args });
}

export function createExportFeedbackCycleJob(args) {
    return post(`${API_URL}/feedback-cycles/` + args.id + '/export/pdf/' + args.perspective, { postData: args });
}
